module.exports = __webpack_public_path__ + "img/31.ee95bb40.jpg";